import {combineReducers} from "redux";
import {reducer as formReducer} from 'redux-form';
import config from './templateConfig/';
import Navigation from './navigation/';
import referralReducer from "./referral";
import authReducer from "./auth";
import financeReducer from "./finance";
import administrationReducer from "./administration";
import gameConfigReducer from "./gameconfig";
import resultReducer from "./result";
import systemConfigReducer from "./systemconfig";
import leapSaleReducer from "./sales";
import lotteryReportsReducer from "./reports";
import bettingConfigReducer from "./bettingconfig";
import transferReducer from "./transfer";
import protectConfigReducer from "./protect";
import analyzeConfigReducer from "./analyze";
import setResultConfigReducer from "./setResult";
import resultDrawReducer from "./resultManual";
import otherSettingReducer from "./othersetting";
import createDrawConfigReducer from "./createDraw";
import tickets from "./newTicket/tickets";
import leapBettingReducer from "./betting";
import numberReducer from "./number";

const rootReducer = combineReducers({
    form: formReducer,
    auth: authReducer,
    referral: referralReducer,
    administration: administrationReducer,
    finance: financeReducer,
    gameConfig: gameConfigReducer,
    systemConfig: systemConfigReducer,
    result: resultReducer,
    lotteryReports: lotteryReportsReducer,
    sale: leapSaleReducer,
    betting: leapBettingReducer,
    bettingConfig: bettingConfigReducer,
    transfer: transferReducer,
    protect: protectConfigReducer,
    analyze: analyzeConfigReducer,
    setResult: setResultConfigReducer,
    resultsDraw: resultDrawReducer,
    otherSetting: otherSettingReducer,
    createDraw: createDrawConfigReducer,
    newTicket: tickets,
    number:numberReducer,
    config,
    Navigation,
});

export default rootReducer;
